import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import VersionSelect from '../../components/FormPage/VersionSelect';
import VersionInfo from '../../components/FormPage/VersionInfo';
import FeaturesInfo from '../../components/FormPage/FeaturesInfo'
import FormSubmitButton from '../../components/FormPage/FormSubmitButton';
import MonitorContainer from './MonitorCard';

export default function VersionForm({ versions }) {
    const { state } = useLocation();
    const [version, setVersion] = useState(state ? state.version : "");
    const [selectedVersionData, setSelectedVersionData] = useState(null);
    useEffect(() => {
        if (version) {
            axios.get(`/api/versionDetails/${version}`)
                .then(r => {
                    setSelectedVersionData(r.data);
                })
        }
    }, [version])

    return (
        <div className="p-6 w-4/5" style={{'marginLeft': '8rem'}}>
            <h1 className="text-3xl py-4 border-b mb-10">Version Select</h1>
            <VersionSelect version={version} versions={versions} setVersion={setVersion} />
            {version && selectedVersionData && (
                <>
                    <VersionInfo versionData={selectedVersionData} />
                    <MonitorContainer version={version} />
                    <FeaturesInfo features={selectedVersionData.features} />
                    {selectedVersionData.Status === "Completed" && (
                        <Link to={{pathname: "/results", state: {type: "version",version}}}>
                            <FormSubmitButton />
                        </Link>
                    )}
                </>
            )}
        </div>
    )
}

